module.exports = __webpack_public_path__ + "img/haiErJf.cdb3425f.png";